<div [@scaleIn] *ngIf="visible" class="dialog">
    <div class="row container">
        <div class="col-md-8">
            <div class="content">
                <img src="../../../assets/images/logo_white.png" width="100px"
                    style="display:inline; margin-right: 15px">
            </div>
        </div>

        <div class="col-md-4 parDiv">
            <p>call us: +27 (0)62 263 1710</p>
        </div>
    </div>
    <hr color="white" class="rounded" size="8" width="100%">
    <h5 class="text-center">Login as Property Owner</h5>
    <div class="form-group col-sm-12">
        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
            {{errorMessage}}
        </div>
    </div>
    <form class="row" [formGroup]="loginForm" (ngSubmit)="submit()">

        <div class="form-group col-sm-12">
            <label for="email">Email </label>
            <input type="text" class="form-control" formControlName="email" id="email" placeholder="email">
        </div>

        <div class="form-group col-sm-12">
            <label for="Password">Password</label>
            <input type="password" class="form-control" formControlName="password" id="password" placeholder="Password">
        </div>


        <div class="form-group col-sm-12">

            <div class="row d-flex justify-content-center" *ngIf="isLoading">
                <img class="loader" src="../../assets/images/loader.gif" width="60px" alt="">
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <button type="submit" class="btn btn-primary m-b-1">Login</button>
                </div>

                <div class="col-sm-6">
                    <button (click)="close()" class="btn btn-primary m-b-1 dialog__close-btn">Close</button>
                </div>
            </div>

        </div>

        <div class="col-md-10">
            <!-- <i class="fa fa-lock"></i> -->
            <h6 style="font-weight: bolder;"><a style="cursor: pointer;" (click)="onNavigateToForgetPassword()"> Forgot
                    Password?</a></h6>
        </div>

        <!-- <div class="col-md-10">
            <h6 style="font-weight: bolder;"><a (click)="" style="cursor: pointer;"> I don't have an account</a></h6>
        </div> -->
    </form>

    <hr color="white" class="rounded" size="8" width="100%">

    <div class="col-md-12 text-center">
        <button class="btn btn-primary btn-google" (click)="signInWithFederatedGoogle()">
            <i class="fa fa-google-plus-square prefix" aria-hidden="true"></i>
            Login With Google
        </button>
    </div>
    <div class="col-md-12 text-center m-t-1">
        <button class="btn btn-primary btn-fb" (click)="signInWithFederatedFacebook()">
            <i class="fa fa-facebook-square prefix" aria-hidden="true"></i>
            Login With FaceBook
        </button>
    </div>
    <div class="col-md-12 text-center m-t-1">
        <button class="btn btn-primary btn-amazon" (click)="signInWithFederatedAmazon()">
            <i class="fa fa-amazon prefix" aria-hidden="true"></i>
            Login With Amazon
        </button>
    </div>
    <div class="empty" style="margin-top: 30px;">
        <!-- empty Space to pad -->
    </div>
</div>